export default "__VITE_ASSET__bf12344d__"